import React, { PureComponent } from "react";
import { Steps, Popover, Spin } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import uuid from "uuid/v4";
import { addActiveEtapa } from "../../../redux/actions/Etapas";
import { getViajes } from "../../../redux/actions/viajes";
import { selectCurrentViaje } from "../../../redux/selectors/viajes";

const Step = Steps.Step;

const customDot = (dot, { index }) => (
  <Popover content={<span>Etapa {index + 1}</span>}>{dot}</Popover>
);

class Etapas extends PureComponent {
  render() {
    const { currentViaje, addActiveEtapa } = this.props;

    return (
      <div style={{ padding: "50px", minHeight: 100 }}>
        <Steps current={0} size="small" progressDot={customDot}>
          {currentViaje.etapas && currentViaje.etapas.length > 0 ? (
            currentViaje.etapas.map((etapa, i) => (
              <Step
                key={uuid()}
                status={etapa.status}
                title={etapa.nombreEtapa}
                onClick={() => addActiveEtapa(i)}
              />
            ))
          ) : (
            <React.Fragment>
              <Spin size="large" />
            </React.Fragment>
          )}
        </Steps>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ addActiveEtapa, getViajes }, dispatch);

const mapStateToProps = state => {
  const currentViaje = selectCurrentViaje(state);
  return {
    currentViaje
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Etapas);
